import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainBannerComponent } from './main-banner/main-banner.component';
import { BannerEditorComponent } from './banner-editor/banner-editor.component';

const routes: Routes = [
  {
    path: 'inicio/:idUsuario/:idCliente',
    component: MainBannerComponent,
    pathMatch: 'full' 
  },
  {
    path: 'nuevo-banner',
    component: BannerEditorComponent,
  },
  { path: '**', redirectTo: 'inicio', pathMatch: 'full' } 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
